import { AppConfig } from "../app-config";

export const DEVELOPMENT_CONFIG: AppConfig = {
    weightSymbol: 'kg',
    siteHost: `http://localhost:3001`,
}